import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=e53ec35e&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53ec35e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e53ec35e')) {
      api.createRecord('e53ec35e', component.options)
    } else {
      api.reload('e53ec35e', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=e53ec35e&scoped=true&", function () {
      api.rerender('e53ec35e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/JVxeDemo/layout-demo/Index.vue"
export default component.exports